import Vue from "vue";
import VueRouter from "vue-router";
import { getUserData, isUserLoggedIn, mustChangePassword, userRole } from "@/auth/utils";
import clients from "@/router/clients";
import delivery from "@/router/delivery";
import banners from "@/router/banners";
import products from "@/router/products";
import order from "@/router/orders";
import shippingCompany from "@/router/shippingcompany";
import defaultcategory from "@/router/defaultcategory";
import marketplaces from "@/router/marketplace";
import affiliates from "@/router/affiliate";
import system from "@/router/system";
import coupons from "@/router/coupons";
import pdv from "@/router/pdv";
import priceMonitoring from "@/router/price-monitoring";
import crossdoking from "@/modules/crossdokking/routes";
import coreCategories from "@/views/Categories/CoreCategories/routes";
import ecommerceSettings from "@/modules/Ecommerce/routes";
import adminRoutes from "@/modules/admin/routes";
import saleChannelsRoutes from "@/modules/marketplace/routes";
import productEnrichmentRoutes from "@/modules/Products/routes";
import integrations from "@/router/integrations";
import integrationModuleRoutes from "@/modules/integration/routes";
import tendenciasRoutes from "@/modules/tendencias/routes";
import onboardingRoutes from "@/modules/Esemente360/routes";
import { storeHasCapability, getStoreFromUser, getDefaultRouteName } from "@/modules/Esemente360/utils/capabilitiesAccess";


// :routes-imports://
Vue.use(VueRouter);

const routes = [
  {
    path: "/usuarios",
    name: "usuarios",
    component: () => import("@/views/users/UsersList.vue"),
    meta: {
      roles: [5],
      pageTitle: "Usuários",
      breadcrumb: [
        {
          text: "Usuários",
          active: true
        }
      ]
    }
  },
  {
    path: "/",
    name: "home",
    component: () => import("@/views/home/GettingStarted.vue"),
    beforeEnter: (to, from, next) => {
      const defaultRoute = getDefaultRouteName(getUserData())
      if (defaultRoute !== "home") {
        return next({ name: defaultRoute });
      }
      if ([4, 8].includes(userRole())) {
        return next({ name: "dashboard" });
      }

      return next();
    },
    meta: {
      need_capability: "dashboard",
      roles: [1, 2, 5, 6, 4, 8],
      pageTitle: "Início",
      breadcrumb: [
        {
          text: "Início",
          active: true
        }
      ]
    }
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("@/views/dashboards/Analytics.vue"),
    meta: {
      need_capability: "dashboard",
      roles: [1, 2, 5, 6,4, 8],
      pageTitle: "Dashboard",
      breadcrumb: [
        {
          text: "Dashboard",
          active: true
        }
      ]
    }
  },
  {
    path: "/actions-store-view",
    name: "actions-store-view",
    component: () => import("@/views/dashboards/ActionsStoreView.vue"),
    meta: {
      roles: [1, 2, 5, 6],
      pageTitle: "Ações do Lojista",
      breadcrumb: [
        {
          text: "Resumo",
          active: true
        }
      ]
    }
  },
  {
    path: "/minha-conta",
    name: "minha-conta",
    component: () => import("@/views/users/account-setting/AccountSetting.vue"),
    meta: {
      roles: [1, 2, 5, 6],
      pageTitle: "Minha Conta",
      breadcrumb: [
        {
          text: "Minha Conta",
          active: true
        }
      ]
    }
  },
  {
    path: "/aprovar-cadastro-produtos",
    name: "approve-product.description.index",
    component: () => import("@/views/products/approval-product-review/ReviewProductList.vue"),
    meta: {
      need_capability: "product_review",
      roles: [1, 2, 5, 6],
      pageTitle: "Produtos",
      breadcrumb: [
        {
          text: "Revisão de produtos",
          active: true
        }
      ]
    }
  },
  {
    path: "/categories",
    name: "product.categories.index",
    component: () => import("@/views/products/categories/CategoriesList.vue"),
    meta: {
      need_capability: "products",
      roles: [1, 2, 5, 6],
      pageTitle: "Categorias",
      breadcrumb: [
        {
          text: "Cadastro de Categoria",
          active: true
        }
      ]
    }
  },
  {
    path: "/product-feed",
    name: "product.feed.index",
    component: () => import("@/views/products/feed/ProductFeed.vue"),
    meta: {
      need_capability: "product_feed",
      roles: [5],
      pageTitle: "Feed de Produtos",
      breadcrumb: [
        {
          text: "Feed de Produtos",
          active: true
        }
      ]
    },
  },

  {
    path: "/login",
    name: "login",
    component: () => import("@/views/LoginCentered.vue"),
    meta: {
      layout: "full"
    }
  },
  {
    path: "/trocar-senha-obrigatoria",
    name: "force-change-password",
    component: () => import("@/views/auth/ForceChangePassword.vue"),
    meta: {
      layout: "full",
      roles: [1, 2, 4, 5, 6, 8],
      pageTitle: "Troca de senha",
    }
  },
  {
    path: "/perdi-minha-senha",
    name: "perdi-minha-senha",
    component: () => import("@/views/auth/ForgotPassword.vue"),
    meta: {
      layout: "full"
    }
  },

  {
    path: "/recuperar-senha/:token",
    name: "recuperar-senha",
    component: () => import("@/views/auth/ResetPassword.vue"),
    meta: {
      layout: "full"
    }
  },
  {
    path: "/error-404",
    name: "error-404",
    component: () => import("@/views/error/Error404.vue"),
    meta: {
      layout: "full"
    }
  },
  {
    path: "*",
    redirect: "error-404"
  }
];
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    ...routes,
    ...clients,
    ...delivery,
    ...banners,
    ...products,
    ...order,
    ...shippingCompany,
    ...defaultcategory,
    ...marketplaces,
    ...affiliates,
    ...system,
    ...coupons,
    ...pdv,
    ...priceMonitoring,
    ...crossdoking,
    ...coreCategories,
    ...ecommerceSettings,
    ...adminRoutes,
    ...saleChannelsRoutes,
    ...productEnrichmentRoutes,
    ...integrations,
    ...integrationModuleRoutes,
    ...tendenciasRoutes,
    ...onboardingRoutes,
// :routes-unpack://
  ]
});
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return new Promise((resolve, reject) => {
    originalPush.call(this, location, () => {
      // on complete

      resolve(this.currentRoute)
    }, error => {
      // on abort

      // only ignore NavigationDuplicated error
      if (error.name === 'NavigationDuplicated') {
        resolve(this.currentRoute)
      } else {
        reject(error)
      }
    })
  })
}
router.beforeEach(async (to, from, next) => {
  let env = process.env.VUE_APP_ENV;
  if (env === "development") {
    env = "production";
  }
  if (to.name === "error-404" || to.name === "login" || to.name === "perdi-minha-senha"
    || to.name === "recuperar-senha" || to.name === "pdv" || to.meta?.public === true || to?.public === true) {
    await router.app.$store.dispatch("route/setLastRoute", from.fullPath);
    return next();
  }
  if (to.name && to.name.length) {
    if (!isUserLoggedIn()) {
      return next({ name: "login" });
    }

    if (mustChangePassword()) {
      if (to.name !== "force-change-password") {
        return next({ name: "force-change-password" });
      }
      await router.app.$store.dispatch("route/setLastRoute", from.fullPath);
      return next();
    }

    if (to.name === "force-change-password") {
      return next({ name: getDefaultRouteName(getUserData()) });
    }

    const roles = to.meta.roles || [];

    if (!roles.find(item => item === userRole())) {
      return next({ name: "login" });
    }
    const requiredService = to.meta.need_service
    if (requiredService) {
      const currentUser = getUserData()
      const storeServices = currentUser?.store?.services || []
      if (!storeServices.find(service => service === requiredService)) {
        return next({ name: "login" })
      }
    }
    const requiredCapability = to.meta.need_capability
    if (requiredCapability) {
      const currentUser = getUserData()
      const store = getStoreFromUser(currentUser)
      if (!storeHasCapability(store, requiredCapability)) {
        return next({ name: getDefaultRouteName(currentUser) })
      }
    }
    let itemEnv = to.meta.env || [env]
    if (userRole() === 5) {
      itemEnv = [env]
    }
    const hasItemEnv = itemEnv.find(cenv => cenv === env)
    if (!hasItemEnv) {
      return next({ name: "login" })
    }
  }

  const url = new URL(window.location.href);
  const lastRoute = url.pathname + url.search;
  await router.app.$store.dispatch("route/setLastRoute", lastRoute);
  return next();
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
